import { Box } from '@mui/material';
import { FormikContextType } from 'formik';
import FormController from '../form_v2/highLevelComponents/FormController';
import { fields } from './type';

export const FormFields = (fields: fields[] | fields[][] | undefined, 
  formik: FormikContextType<any>) => {

  return (
    <>
      {fields?.map((item: any) => {
        if (Array.isArray(item)) {
          return <Box display='flex'
            flexDirection={{xs: 'column', md: 'row'}}
            gap={{xs: 0, md: 10}}
            key={item + 'Box'}>
            {item.map((subEl) => {
              return (
                <div style={{ width: '100%' }}
                  key={subEl.name}
                >
                  <FormController
                    {...subEl}
                    formik={formik}
                  />
                </div>
              );
            })}
          </Box>;
        }
        return (
          <FormController key={item.name} formik={formik}
            {...item} />
        );
      })}
    </>
  );
};